import React, { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import Accordion from "react-bootstrap/Accordion";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Link from "next/link";
import { useRouter } from "next/router";
import {
  getCartDataFromServer,
  loggedInUserCartId,
  removeItemFromCart,
  applyCouponToCart,
  removeCouponFromCart,
  updateCart,
} from "../../api.services.js/cart";
import { FaTrashAlt } from "react-icons/fa";
import Loader from "../../src/components/loader";
import swal from "sweetalert";
import Head from "next/head";
import { AES } from "crypto-js";

const Cart = () => {
  const [cartData, setCartData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [coupon, setCoupon] = useState("");
  useEffect(() => {
    getCartData();
  }, []);

  let fireUnbxdOrder = (unxPayload) => {
    console.log(unxPayload, "unxPayload payload");
    setTimeout(function () {
      if (window.Unbxd) {
        Unbxd.trackMultiple("order", unxPayload);
      } else {
        console.log("Unbxd is not defined");
      }
    }, 2000);
  };
  let getCartData = async () => {
    // decrypt token
    const token = AES.decrypt(
      localStorage.getItem("userToken"),
      process.env.NEXT_PUBLIC_SECRET_KEY
    ).toString();

    if (localStorage.getItem("userToken") && !localStorage.getItem("cartId")) {
      let cartId = await loggedInUserCartId({ token });
      localStorage.setItem("cartId", cartId.data.customerCart.id);
      let loggedInUserCartData = await getCartDataFromServer({
        cartId: cartId.data.customerCart.id,
        token,
      });
      setCartData(loggedInUserCartData.data.cart);
      // fireUnbxdOrder(loggedInUserCartData.data.cart.items.map((cc)=>{
      //   return {
      //       pid: cc.product.sku,
      //       qty: cc.prices.price.value,
      //       price: cc.quantity
      //   }
      // }))
      setLoading(false);
    } else if (
      localStorage.getItem("userToken") &&
      localStorage.getItem("cartId")
    ) {
      let loggedInUserCartData = await getCartDataFromServer({
        cartId: localStorage.getItem("cartId"),
        token,
      });
      setCartData(loggedInUserCartData.data.cart);
      // fireUnbxdOrder(loggedInUserCartData.data.cart.items.map((cc)=>{
      //   return {
      //       pid: cc.product.sku,
      //       variantId: "", // Only if variant is present
      //       qty: cc.prices.price.value,
      //       price: cc.quantity
      //   }
      // }))
      setLoading(false);
    } else if (localStorage.getItem("cartId")) {
      let guestCart = await getCartDataFromServer({
        cartId: localStorage.getItem("cartId"),
      });
      setCartData(guestCart.data?.cart);
      // fireUnbxdOrder(guestCart.data.cart.items.map((cc)=>{
      //   return {
      //       pid: cc.product.sku,
      //       variantId: "", // Only if variant is present
      //       qty: cc.prices.price.value,
      //       price: cc.quantity
      //   }
      // }))
      setLoading(false);
    } else {
      setLoading(false);
    }
    console.log(cartData);
  };

  const router = useRouter();

  const handleGoBack = () => {
    router.back();
  };

  const removeFromCart = async (e) => {
    // setCartData(null);
    let obj = {
      cartId: localStorage.getItem("cartId"),
      cartItemId: e.id,
    };
    if (localStorage.getItem("userToken")) {
      // decrypt token
      obj = {
        ...obj,
        token: AES.decrypt(
          localStorage.getItem("userToken"),
          process.env.NEXT_PUBLIC_SECRET_KEY
        ).toString(),
      };
    }
    let response = await removeItemFromCart(obj);
    if (response?.message) {
      swal(response?.message);
    } else {
      setCartData(response.data.removeItemFromCart.cart);
      localStorage.setItem(
        "CartData",
        JSON.stringify(response.data.removeItemFromCart.cart)
      );
      swal(`${e.product.name} removed from your cart`);
      const storageChangeEvent = new CustomEvent("localCartChanged", {
        detail: { key: "CartData", newValue: "" },
      });
      //  window.dispatchEvent(new Event('storage'));
      window.dispatchEvent(storageChangeEvent);
    }
  };
  const callUpdateCart = async () => {
    let tempvar = false;
    let arr = cartData.items.map((cur) => {
      if (cur.prices.price.value == 0 && cur.quantity > 1) {
        tempvar = true;
      }
      return {
        cart_item_uid: cur.uid,
        quantity: cur.quantity
          ? cur.prices.price.value == 0 && cur.quantity
            ? 1
            : cur.quantity
          : 1,
      };
    });
    if (tempvar) {
      swal("You can't order more than 1 quantity for sample");
      return;
    }
    let obj = {
      cartId: localStorage.getItem("cartId"),
      cartItems: arr,
    };
    if (localStorage.getItem("userToken")) {
      obj = {
        ...obj,
        token: AES.decrypt(
          localStorage.getItem("userToken"),
          process.env.NEXT_PUBLIC_SECRET_KEY
        ).toString(),
      };
    }
    let response = await updateCart(obj);
    if (response?.message) {
      swal(response?.message);
    } else {
      setCartData(response.data.updateCartItems.cart);
      localStorage.setItem(
        "CartData",
        JSON.stringify(response.data.updateCartItems.cart)
      );
      swal(`Your cart updated Succesfully`);
      const storageChangeEvent = new CustomEvent("localCartChanged", {
        detail: { key: "CartData", newValue: "" },
      });
      window.dispatchEvent(storageChangeEvent);
    }
  };

  const applyCoupon = async () => {
    // setCartData(null);
    if (!coupon.trim()) {
      swal("Please enter a valid coupon code.");
      return;
    }
    let obj = {
      cartId: localStorage.getItem("cartId"),
      couponCode: coupon,
    };
    if (localStorage.getItem("userToken")) {
      obj = {
        ...obj,
        token: AES.decrypt(
          localStorage.getItem("userToken"),
          process.env.NEXT_PUBLIC_SECRET_KEY
        ).toString(),
      };
    }
    let response = await applyCouponToCart(obj);
    if (response?.message) {
      swal(response?.message);
    } else {
      setCartData(response.data.applyCouponToCart.cart);
      localStorage.setItem(
        "CartData",
        JSON.stringify(response.data.applyCouponToCart.cart)
      );
      swal(`Coupon applied on cart.`);
      const storageChangeEvent = new CustomEvent("localCartChanged", {
        detail: { key: "CartData", newValue: "" },
      });
      //  window.dispatchEvent(new Event('storage'));
      window.dispatchEvent(storageChangeEvent);
    }
  };

  const removeCoupon = async () => {
    let obj = {
      cartId: localStorage.getItem("cartId"),
    };
    if (localStorage.getItem("userToken")) {
      obj = {
        ...obj,
        token: AES.decrypt(
          localStorage.getItem("userToken"),
          process.env.NEXT_PUBLIC_SECRET_KEY
        ).toString(),
      };
    }
    let response = await removeCouponFromCart(obj);
    if (response?.message) {
      swal(response?.message);
    } else {
      setCartData(response.data.removeCouponFromCart.cart);
      localStorage.setItem(
        "CartData",
        JSON.stringify(response.data.removeCouponFromCart.cart)
      );
      swal(`Coupon removed from the cart.`);
      const storageChangeEvent = new CustomEvent("localCartChanged", {
        detail: { key: "CartData", newValue: "" },
      });
      //  window.dispatchEvent(new Event('storage'));
      window.dispatchEvent(storageChangeEvent);
      setCoupon("");
    }
  };

  return (
    <>
      <Head>
        <title>Orientbell Tiles - Shopping Cart Overview</title>
        <meta
          name="title"
          content="Orientbell Tiles - Shopping Cart Overview"
        />
        <meta
          name="description"
          content="Review your chosen tiles in the Orientbell cart. Update quantities, view item details, and get closer to completing your tile purchase for your project."
        />
      </Head>
      {loading ? (
        <Loader />
      ) : (
        <div className="checkout_cart_page">
          <div className="container">
            <h2>
              <span>Shopping Cart</span>
            </h2>
            {!cartData || cartData?.items?.length == 0 ? (
              <div className="shopping_cart_noitem">
                <p>You have no items in your shopping cart.</p>
                <p>
                  Click <Link href="#">here</Link> to continue shopping.
                </p>
              </div>
            ) : (
              <div className="shopping_cart">
                <div className="shopping_cart_data_right">
                  <h4>
                    <span>Summary</span>
                  </h4>
                  <div className="summary_data_cart">
                    <p>
                      Subtotal{" "}
                      <span>
                        ₹ {cartData.prices.subtotal_including_tax.value}
                      </span>
                    </p>
                    {cartData.shipping_addresses &&
                      cartData.shipping_addresses?.length > 0 &&
                      cartData.shipping_addresses[0]
                        .selected_shipping_method && (
                        <p>
                          Shipping (
                          {
                            cartData.shipping_addresses[0]
                              .selected_shipping_method.carrier_title
                          }
                          ){" "}
                          <span>
                            ₹{" "}
                            {
                              cartData.shipping_addresses[0]
                                .selected_shipping_method.amount.value
                            }
                          </span>
                        </p>
                      )}
                  </div>
                  {cartData.prices.discount && (
                    <div className="summary_data_cart">
                      <p>
                        Discount{" "}
                        <span>₹ {cartData.prices.discount.amount.value}</span>
                      </p>
                    </div>
                  )}
                  <div className="summary_data_cart">
                    <p>
                      Order Total{" "}
                      <span>₹ {cartData.prices.grand_total.value}</span>
                    </p>
                  </div>
                  <Accordion>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>Apply Discount Code</Accordion.Header>
                      <Accordion.Body>
                        <Form
                          onSubmit={(e) => {
                            e.preventDefault();
                            applyCoupon();
                          }}
                        >
                          <Form.Group
                            className="mb-3"
                            controlId="formBasicEmail"
                          >
                            <Form.Label>Enter discount code</Form.Label>
                            {cartData?.applied_coupons &&
                            cartData?.applied_coupons[0]?.code ? (
                              <Form.Control
                                type="text"
                                placeholder="Enter discount code"
                                value={cartData.applied_coupons[0]?.code}
                              />
                            ) : (
                              <Form.Control
                                type="text"
                                value={coupon}
                                placeholder="Enter discount code"
                                onChange={(e) => setCoupon(e.target.value)}
                              />
                            )}
                          </Form.Group>
                          {cartData?.applied_coupons &&
                          cartData?.applied_coupons[0]?.code ? (
                            <Button
                              variant="outline-primary"
                              onClick={() => {
                                removeCoupon();
                              }}
                            >
                              Remove Coupon
                            </Button>
                          ) : (
                            <Button
                              variant="outline-primary"
                              type="submit"
                              value={coupon}
                              onClick={() => {
                                applyCoupon();
                              }}
                            >
                              Apply Discount
                            </Button>
                          )}
                        </Form>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>

                  <Button
                    variant="primary"
                    type="submit"
                    onClick={() => {
                      router.push("/checkout");
                    }}
                  >
                    Proceed to Checkout
                  </Button>
                  <div className="cart_images">
                    <img
                      src="../footer-paymet2_1_1.webp"
                      alt="Image"
                      style={{ width: "100%" }}
                    />
                  </div>
                  <h3>
                    <span>Why Orientbell Tiles ?</span>
                  </h3>
                  <ul>
                    <li>Premium Quality products</li>
                    <li>
                      Door step delivery in 7 days (50% orders delivered in 7
                      days)
                    </li>
                    <li>100% refund if not happy with delivery date</li>
                    <li>Assisted order processing</li>
                    <li>5 samples for Rs.500/-</li>
                    <li>Delivery from nearest Orientbell store</li>
                  </ul>
                </div>
                <div className="shopping_cart_data_left">
                  <Table responsive>
                    <thead>
                      <tr className="thead_th">
                        <th>Item</th>
                        <th>Price</th>
                        <th>Qty</th>
                        <th>Subtotal</th>
                      </tr>
                    </thead>
                    {cartData.items?.length > 0 &&
                      cartData?.items?.map((obj, index) => {
                        let subTotal = obj?.prices?.row_total.value;

                        return (
                          <tbody
                            className="tbody_th"
                            key={index}
                            id={obj.product.sku}
                          >
                            <tr>
                              <td className="tbody_th_item_img">
                                <span>item</span>
                                <div className="item_data_cart">
                                  <img
                                    src={obj.product.image.url}
                                    alt="image"
                                  />
                                  <Link href="#">{obj.product.name}</Link>
                                </div>
                              </td>
                              <td
                                className="tbody_th_item"
                                style={{ marginLeft: "0" }}
                              >
                                <span>Price</span> {obj?.prices?.price?.value}
                              </td>
                              <td className="tbody_th_item">
                                <span>Quantity</span>{" "}
                                <input
                                  type="number"
                                  value={obj.quantity}
                                  style={{ width: "40px", textAlign: "center" }}
                                  onChange={(e) => {
                                    setCartData({
                                      ...cartData,
                                      items: cartData.items.map((cur, i) => {
                                        if (index == i) {
                                          return {
                                            ...cur,
                                            quantity: e.target.value,
                                          };
                                        } else {
                                          return cur;
                                        }
                                      }),
                                    });
                                  }}
                                />
                              </td>
                              <td className="tbody_th_item">
                                <span>Subtotal</span> ₹ {subTotal}
                              </td>
                              <td
                                className="tbody_th_item"
                                onClick={() => removeFromCart(obj)}
                              >
                                <FaTrashAlt className="deleteICon" />
                              </td>
                            </tr>
                            {/* <tr>
              <Button variant='outline-primary'  onClick={()=>removeFromCart(obj)}> Remove item</Button>
              </tr> */}
                          </tbody>
                        );
                      })}
                  </Table>
                  <div className="cont_shopping_btn">
                    <Link href="/" className="btn btn-outline-primary">
                      {" "}
                      Continue Shopping
                    </Link>
                    <Button onClick={callUpdateCart} variant="outline-primary">
                      {" "}
                      Update Shopping Cart
                    </Button>
                  </div>
                </div>
              </div>
            )}
            <Button variant="primary" onClick={handleGoBack}>
              Back
            </Button>
            <img
              src="../orientbell_web_flowchart_1.webp"
              alt="image"
              style={{ width: "100%", marginTop: "30px" }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default Cart;
